import { render } from "./ShareWith.vue?vue&type=template&id=6927b775"
import script from "./ShareWith.vue?vue&type=script&lang=js"
export * from "./ShareWith.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__